import { v4 as uuidv4 } from "uuid";
import { notify } from "../api/photoshop";
import { photoshop } from "../globals";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";

const callTest = async () => {
	let success = false;
	await photoshop.core.executeAsModal(
		async () => {
			const doc = photoshop.app.activeDocument;
			await doc.suspendHistory(async () => {
				try {
					if (doc.activeLayers.length === 0) {
						await notify("Select a layer");
						return;
					}
					const selBounds = doc.selection.bounds;
					if (!selBounds) {
						await notify("Selection area is empty");
						return;
					}

					if (!doc.selection.solid) {
						await notify(
							"Selection area must be a square, with equal width and height.",
						);
						return;
					}
					const selectedLayers = doc.activeLayers;
					const copiedLayers = await doc.duplicateLayers(selectedLayers);
					const groupLayer = await doc.groupLayers(copiedLayers);
					const layer = await groupLayer?.merge();
					if (!layer) {
						await notify("Failed to merge layers");
						return;
					}

					layer.name = "Processing...";
					layer.selected = true;

					success = true;
				} catch (err) {
					console.error(err);
					await notify(`${err}`);
				}
			}, "Test");
		},
		{
			commandName: "Test",
		},
	);
	return success;
};

export function useListenTestMessage() {
	useListenFromRenderer([
		{
			key: "test",
			onMessage: async (message) => {
				const success = await callTest();
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
